import axios from 'axios';
import Amplify, { Auth } from 'aws-amplify';
import amplifyConfig from '../constants/amplify.config';
import UsersService from '../services/userService';

Amplify.configure(amplifyConfig);

async function startPasswordRecovery(username) {
  const reset = await Auth.forgotPassword(username);

  return reset;
}

async function resetPassword(username, code, password) {
  await Auth.forgotPasswordSubmit(username, code, password);

  await UsersService.login(username, password);
}

export default {
  startPasswordRecovery,
  resetPassword,
};



// WEBPACK FOOTER //
// ./src/authentication/resetPassword.js